import { useCallback, useInsertionEffect, useRef } from 'react'

export function useEffectEvent<T extends (...args: any[]) => any>(callback: T): T {
	const callbackRef = useRef(callback)

	useInsertionEffect(() => {
		callbackRef.current = callback
	}, [callback])

	const stableCallback = useCallback(
		((...args: Parameters<T>): ReturnType<T> => {
			return callbackRef.current(...args)
		}) as T,
		[],
	)

	return stableCallback
}
